const validCode = code => /^(?:(?:sh|sz|bj)\d{6}|hk[A-Za-z0-9]{3,12}|us\.?[A-Za-z0-9][A-Za-z0-9._-]{0,39})$/i.test(String(code || ''))
const validPeriod = period => ['day', 'week', 'month'].includes(period)

export function createMarketRequest(kind, params = {}) {
  const qq = 'https://proxy.finance.qq.com'
  const code = String(params.code || '')
  if (kind === 'cn-trades') {
    if (!/^(sh|sz|bj)\d{6}$/i.test(code)) throw new Error('无效的A股代码')
    return { method: 'get', url: `${qq}/ifzqgtimg/appstock/app/dealinfo/getMingxiV2`, params: { code, limit: 25, direction: 1 } }
  }
  if (['minute', 'chart-minute', 'chart-days', 'chart-kline', 'trades', 'us-trades', 'us-kline', 'us-minute', 'us-days'].includes(kind) && !validCode(code)) throw new Error('无效的行情代码')
  const chart = () => ({ method: 'get', url: `${qq}/ifzqgtimg/appstock/app/minute/query`, params: { code } })
  if (kind === 'minute') return chart()
  if (kind === 'chart-minute' || kind === 'chart-days') return { method: 'get', url: `https://web.ifzq.gtimg.cn/appstock/app/${kind === 'chart-days' ? 'day' : 'minute'}/query`, params: { code } }
  if (kind === 'chart-kline') {
    if (!validPeriod(params.period)) throw new Error('无效的K线周期')
    const fq = params.right === 1 ? 'qfq' : params.right === 2 ? 'hfq' : ''
    return { method: 'get', url: `${qq}/ifzqgtimg/appstock/app/${fq ? 'newfqkline/get' : 'newkline/newkline'}`, params: { param: `${code},${params.period},,,320,${fq}` } }
  }
  if (kind === 'summary' && params.market === 'cn') return { method: 'get', url: `${qq}/cgi/cgi-bin/market/hs/index` }
  if (kind === 'cn-boards') return { method: 'get', url: `${qq}/ifzqgtimg/appstock/app/board/index` }
  if (kind === 'trades' || kind === 'us-trades') return { method: 'get', url: `${qq}/cgi/cgi-bin/detail/all`, params: { code, start: -1, count: 30 } }
  if (kind === 'us-kline') {
    if (!validPeriod(params.period)) throw new Error('无效的K线周期')
    return { method: 'get', url: `${qq}/ifzqgtimg/appstock/app/newkline/newkline`, params: { param: `${code},${params.period},,,320,` } }
  }
  if (kind === 'us-minute' || kind === 'us-days') return { method: 'get', url: `https://web.ifzq.gtimg.cn/appstock/app/${kind === 'us-days' ? 'dayus' : 'UsMinute'}/query`, params: { code } }
  throw new Error('不支持的行情请求')
}
